


























import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class SectionUploadFile extends Vue {
  @Prop({}) readonly transactionCreate!: any;

  private fileName = "";
  private fileType = "";

  public SelectFile() {
    const refInputFile: any = this.$refs.inputFile;
    refInputFile.click();
  }

  public onChange(e: any) {
    const files = e.target.files;
    this.checkFile(files);
  }

  public async checkFile(file: any) {
    const currentTime = Date.now();
    const fileNameDuplicate = this.transactionCreate.fileList.some(
      (fileItem: any) => fileItem.fileName === file[0].name
    );
    if (this.transactionCreate.fileList && this.transactionCreate.fileList.length >= 1 && fileNameDuplicate) {
      const spiltTypeFile = file[0].name.split(".");
      this.fileName = spiltTypeFile[0] + "_" + currentTime + "." + spiltTypeFile[1];
      this.fileType = file[0].type;
    } else {
      this.fileName = file[0].name;
      this.fileType = file[0].type;
    }

    await this.ReaderFile(this.fileName, this.fileType, file[0]);
  }

  public async ReaderFile(fileName: string, fileType: string, file: File) {
    const reader = new FileReader();

    reader.readAsDataURL(file);

    reader.onload = (e: ProgressEvent<FileReader>) => {
      if (e.target) {
        const result = e.target.result as string;
        this.transactionCreate.fileList.push({
          fileName: fileName,
          fileType: fileType,
          rawString: result,
        });
      }
    };
  }

  public CheckTypeFile(fileType: string) {
    let typeImg = false;
    switch (fileType) {
      case "image/jpeg":
      case "image/gif":
      case "image/png":
        typeImg = true;
        break;
      default:
        typeImg = false;
        break;
    }
    return typeImg;
  }

  public RemoveFile(index: number) {
    this.transactionCreate.fileList.splice(index, 1);
  }
}
